import React from "react";
import Header from "./Header";
import Navigation from "./Navigation";
import ChatInterface from "./ChatInterface";
import "./Layout.css";

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <Header />
      <main className="main-content">{children}</main>
      <ChatInterface />
      <Navigation />
    </div>
  );
};

export default Layout;
